import { Leaf } from "lucide-react";
import { C } from "./brandTokens";

export default function LandingFooter() {
  return (
    <footer className="py-9 px-6 sm:px-10" style={{ background: "#2A2118" }}>
      <div className="max-w-[900px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Leaf size={14} className="text-spec-sage" />
          <span className="font-heading text-[17px] font-semibold" style={{ color: "rgba(250,248,243,0.7)" }}>
            Eden Pages
          </span>
        </div>
        <div className="flex gap-6">
          {[
            { label: "Privacy", href: "/terms#privacy" },
            { label: "Terms", href: "/terms" },
            { label: "Contact", href: "mailto:support@edenpages.com" },
          ].map(l => (
            <a key={l.label} href={l.href} className="font-ui text-[13px] no-underline transition-colors hover:opacity-80" style={{ color: "rgba(250,248,243,0.45)" }}>
              {l.label}
            </a>
          ))}
        </div>
        <span className="font-ui text-[13px]" style={{ color: "rgba(250,248,243,0.35)" }}>
          © 2026 Eden Pages
        </span>
      </div>
    </footer>
  );
}
